import { scroller } from "react-scroll";

/**
 * Smoothly scrolls to a target element using react-scroll.
 * @param target - The name of the Element to scroll to.
 */
export const scrollToSection = (target: string): void => {
    scroller.scrollTo(target, {
        duration: 600,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -80, // adjust for fixed headers if needed
    });
};